module.exports = __webpack_public_path__ + "img/course_bg.e115189b.webp";